<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >Asignar contratista</span
            >
            <button
                style="float: right"
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>
    <mat-dialog-content class="p-16 pb-0 m-0">
        <form
            *ngIf="formAsignacion"
            class="form mt-8 mb-24"
            [formGroup]="formAsignacion"
            autocomplete="off"
        >
            <mat-form-field class="full-width">
                <mat-label>Inicio y término del trabajo</mat-label>
                <mat-date-range-input
                    [formGroup]="rango"
                    [rangePicker]="picker"
                >
                    <input
                        matStartDate
                        formControlName="inicio"
                        placeholder="Fecha de inicio"
                        readonly
                        required
                    />
                    <input
                        matEndDate
                        formControlName="termino"
                        placeholder="Fecha de término"
                        readonly
                        required
                    />
                </mat-date-range-input>
                <mat-datepicker-toggle
                    matSuffix
                    [for]="picker"
                ></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>

                <mat-error *ngIf="inicio.hasError('matStartDateInvalid')"
                    >Fecha de inicio inválida</mat-error
                >
                <mat-error *ngIf="termino.hasError('matEndDateInvalid')"
                    >Fecha de término inválida</mat-error
                >
            </mat-form-field>

            <!-- <mat-form-field class="full-width">
                <mat-label>Fecha de inicio </mat-label>

                <input
                    matInput
                    [matDatepicker]="fechaInicioDatepicker"
                    name="fechaInicio"
                    formControlName="fechaInicio"
                    readonly
                    required
                />
                <mat-datepicker-toggle
                    matSuffix
                    [for]="fechaInicioDatepicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #fechaInicioDatepicker></mat-datepicker>
                <mat-error *ngIf="fechaInicio.hasError('required')">
                    Debe ingresar la fecha de inicio de los trabajos
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>Fecha de término </mat-label>

                <input
                    matInput
                    [matDatepicker]="fechaTerminoDatepicker"
                    name="fechaTermino"
                    formControlName="fechaTermino"
                    readonly
                    required
                />
                <mat-datepicker-toggle
                    matSuffix
                    [for]="fechaTerminoDatepicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #fechaTerminoDatepicker></mat-datepicker>
                <mat-error *ngIf="fechaTermino.hasError('required')">
                    Debe ingresar la fecha de término de los trabajos
                </mat-error>
            </mat-form-field> -->
        </form>
    </mat-dialog-content>
    <mat-divider></mat-divider>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cancelar</button>

        <button
            mat-raised-button
            color="accent"
            [disabled]="!formAsignacion.valid"
            [mat-dialog-close]="formAsignacion.value"
        >
            Asignar
        </button>
    </mat-dialog-actions>
</div>
